import type { ResourceExceptionKind } from './findings-exception-helpers'
import { Label } from '@deepguide-ai/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@deepguide-ai/ui/select'

/**
 * "Applies to" field of the exception popover (RFC-182): FINDING = this
 * check only, SCOPE = the entire resource across all checks. Shared by
 * ProviderCheckDetailSheet (cloud-scan side) and ApiCheckViolationsDialog
 * (CES side) so the scope UX can't drift between entry points.
 */
export function ExceptionKindSelect({
  value,
  onChange,
  disabled = false,
}: {
  value: ResourceExceptionKind
  onChange: (kind: ResourceExceptionKind) => void
  disabled?: boolean
}) {
  return (
    <div className='space-y-1.5'>
      <Label className='font-body text-text-body text-[11px]'>Applies to</Label>
      <Select
        value={value}
        onValueChange={(v) => onChange(v as ResourceExceptionKind)}
        disabled={disabled}
      >
        <SelectTrigger fullWidth  className='h-8 text-[12px]'>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value='FINDING' className='text-[12px]'>
            This check only
          </SelectItem>
          <SelectItem value='SCOPE' className='text-[12px]'>
            Entire resource (all checks)
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
